export default "__VITE_ASSET__c30c4377__"